export default "__VITE_ASSET__DGUl3xwY__"